
import { useLanguage } from '@/hooks/useLanguage';

export function NewsLoading() {
  const { t } = useLanguage();
  
  return (
    <div className="flex justify-center items-center h-64">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
        <p className="mt-4 text-muted-foreground">{t('news.loading')}</p>
      </div>
    </div>
  );
}
